import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './Login.css';
import { useAuth } from "../../contexts/AuthContext"
import { useHistory } from "react-router-dom"
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import logo from "../../assets/phytocore_white.png"
import ReCAPTCHA from "react-google-recaptcha";
import ResetPasswordDialog from "./ResetPassword"

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '35ch',
    },
  },
}));

export default function Login({ setToken }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [success, setSuccess] = useState(false);
  const [recaptcha, setRecaptcha] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const { login, currentUser } = useAuth()
  const history = useHistory()
  const classes = useStyles();
  const recaptchaRef = React.useRef();
  const site_key = process.env.REACT_APP_RECAPTCHA_SITE_KEY

  async function loginUser(credentials) {
    login(credentials.username, credentials.password).then(
      res => {
        setLoading(false)
        setSuccess(true)
    }).catch(error => {
      console.log(error.message)
      setError("Incorrect email or password.")
      setLoading(false)
      recaptchaRef.current.reset()
    })
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true)
    if (recaptcha) {
      await loginUser({username, password})
        history.push("/")
    } else {
      setError("Please verify recaptcha.")
      setLoading(false)
    }
  }

  useEffect(()=> {
    async function fetchToken(idToken) {
      let response = await fetch('/auth', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify({
        IdToken: idToken,
        ReCaptcha: recaptcha, 
       })
     })
      response = await response.json()
      setToken(response)
    }
    if (success) {
      currentUser.getIdToken().then((idToken) =>{
        fetchToken(idToken)  
        setRecaptcha('')
      })
    }
  }, [success]);

  const LoginButton = withStyles((theme) => ({
    root: {
      marginLeft: "auto",
      marginTop: 30,
      width: "45ch",
      color: "#fff",
      backgroundColor: "#304B42",
      '&:hover': {
        backgroundColor: "#406458",
      },
    },
  }))(Button);

  const onRecaptcha = (value) => {
    setRecaptcha(value)
  }

  return(
    <div>
    <Grid container className="logo-wrapper">
      <img className="img" src={logo}/>
    </Grid>
    <Grid container alignItems="center" justify="center" className="login-wrapper">
    <Grid>
      <Paper elevation={3} className="form" >
      <form className={classes.root} onSubmit={handleSubmit}>
          <TextField  size="normal"
          id="email" label="email" 
          onChange={e => setUserName(e.target.value)} />
          <TextField 
            id="password" label="password" type="password" size="normal"
            onChange={e => setPassword(e.target.value)} />
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={site_key}
          onChange={onRecaptcha}
        />
          <LoginButton type="submit" onSubmit={handleSubmit}>Sign In</LoginButton>
        <div className="error">
          {error}
        </div>
        <div>
          <ResetPasswordDialog />
        </div>
      </form>
      </Paper>
    </Grid>
    </Grid>
    <Grid container className="footer-wrapper"/>
    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};

 

